import { render, staticRenderFns } from "./MstHeaderButton.vue?vue&type=template&id=6f795a6e&scoped=true&"
import script from "./MstHeaderButton.vue?vue&type=script&lang=js&"
export * from "./MstHeaderButton.vue?vue&type=script&lang=js&"
import style0 from "./MstHeaderButton.vue?vue&type=style&index=0&id=6f795a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f795a6e",
  null
  
)

export default component.exports